// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__SKks5","form":"EditProfile_form__AkeXs","userImage":"EditProfile_userImage__byu52"};